// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './authentication'
import todo from '@src/views/apps/todo/store'
import chat from '@src/views/apps/chat/store'
import users from '@src/views/apps/users/store'
import customers from  '@src/views/apps/customers/store'
import templates from  '@src/views/apps/template/store'
import campaigns from  '@src/views/apps/campaign/store'
import email from '@src/views/apps/email/store'
import invoice from '@src/views/apps/invoice/store'
import calendar from '@src/views/apps/calendar/store'
import ecommerce from '@src/views/apps/ecommerce/store'
import dataTables from '@src/views/tables/data-tables/store'
import permissions from '@src/views/apps/roles-permissions/store'
import documents from '@src/views/apps/document/store'
import payments from '@src/views/apps/payment/store'
import newcampaigns from  '@src/views/apps/create-campaign/store'
import costs from '@src/views/apps/cases/store/costs'
import files from '@src/views/apps/cases/store/files'
import caseAssistants from '@src/views/apps/cases/store/assistants'

const rootReducer = {
  auth,
  todo,
  chat,
  email,
  users,
  customers,
  templates,
  campaigns,
  documents,
  payments,
  navbar,
  layout,
  invoice,
  calendar,
  ecommerce,
  dataTables,
  permissions,
  newcampaigns,
  costs,
  files,
  caseAssistants
}

export default rootReducer